import React from "react";
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import { CircularProgress } from "@mui/material"; 
import { useNavigate } from "react-router";


export default ({children, installPrompt}) => {
  const [user, loading] = useAuthState(auth)
  const navigate = useNavigate();
    
  if (loading) {
    return <><CircularProgress /></>
  } 

  if (user == null) {
    return navigate('/login')
  }
  
  return <>{children}</>
}